import Vue from 'vue'
import configs from '@/config'

let resource = null
const scimApiPath = `${configs.baseUrl}/api/scim/v2`

const actions = {
  generateApiKey: {
    method: 'POST',
    url: `${scimApiPath}/api-keys`,
  },
  getApiKeys: {
    method: 'GET',
    url: `${scimApiPath}/api-keys`,
  },
  updateApiKey: {
    method: 'PATCH',
    url: `${scimApiPath}/api-keys/{apiKeyId}`,
  },
  deleteApiKey: {
    method: 'DELETE',
    url: `${scimApiPath}/api-keys/{apiKeyId}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const generateApiKey = async (params) => {
    const res = await resource.generateApiKey(params)
    return res.body
}

// the return schema is below
// return {
//       data: rows,
//       pagination: {
//         total,
//         page,
//         limit,
//         totalPages,
//       },
//}
const getApiKeys = async (params) => {
    const res = await resource.getApiKeys(params)
    return res.body
}

const updateApiKey = async (apiKeyId, params) => {
    const res = await resource.updateApiKey({ apiKeyId }, params)
    return res.body
}

const deleteApiKey = async (params) => {
    const res = await resource.deleteApiKey(params)
    return res.body
}

export default {
  initResource,
  generateApiKey,
  getApiKeys,
  updateApiKey,
  deleteApiKey,
}